import React, {memo} from 'react';
import './MferHead.css';
import CONSTANTS from '../constants';

export function isDeadPiece(type) {
    return !isAlivePiece(type);
}
export function isNormalPiece(type) {
    return type >= 1 && type <= 6;
}
export function isLobesy(type) {
    return type === 7;
}
export function isAlivePiece(type) {
    return isNormalPiece(type) || isLobesy(type);
}
export function turnAlivePieceDead(aliveType) {
    // assume its alive
    return aliveType + CONSTANTS.N_DEAD_ZONE;
}
function areEqual(prevProps, nextProps) {
    
    const prevIsSelected = prevProps.selectedJewel !== null
    ? (prevProps.selectedJewel.colIndex === prevProps.y && prevProps.selectedJewel.rowIndex === prevProps.x)
    : false;

    const nextIsSelected = nextProps.selectedJewel !== null
        ? (nextProps.selectedJewel.colIndex === nextProps.y && nextProps.selectedJewel.rowIndex === nextProps.x)
        : false;

    const same = prevProps.type === nextProps.type && prevIsSelected === nextIsSelected;
    // if (!same) {
    //     console.log("previous selected jewel ", prevProps.selectedJewel);
    //     console.log("next selected jewel ", nextProps.selectedJewel);
    //     console.log("is same for ", nextProps.x, ",", nextProps.y, ",", same);
    // }
    return same;

}

export const MferHead = memo(function MferHead({ type, x, y, selectedJewel, shouldBeCleared, onClick, imageMap, levelID}) {
    const isSelected=(selectedJewel && selectedJewel.colIndex === y && selectedJewel.rowIndex === x);

    const getImageSrc = () => {
        if (type === 7) {
            if (levelID === "nakamigo_crush") {
                return '/mfersbeheaded/images/naka/nakaking-nobg.png';
            } else if (levelID === "tiny_dino" || levelID === "tiny_dinos_automated") {
                return '/mfersbeheaded/images/tinydinos/charizard.png';
            
            } else if (levelID === "book_of_bee" || levelID === "book_of_bee_automated") {
                return '/mfersbeheaded/images/pepeheads/darth_pepe.png';
            } else if (levelID === "p2p_mfer_system") {
                return '/mfersbeheaded/images/mferprototype.png';
            }
            return '/mfersbeheaded/images/heads/7235.png';
        } else if (type === 1007) {
            if (levelID === "nakamigo_crush") {
                return '/mfersbeheaded/images/naka/nakaking-nobg.png';
            } else if (levelID === "tiny_dino" || levelID === "tiny_dinos_automated") {
                return '/mfersbeheaded/images/tinydinos/charizard.png';
            } else if (levelID === "book_of_bee" || levelID === "book_of_bee_automated") {
                return '/mfersbeheaded/images/pepeheads/darth_pepe.png';
            } else if (levelID === "p2p_mfer_system") {
                return '/mfersbeheaded/images/mferprototype.png';
            }
            return '/mfersbeheaded/images/heads/7235.png';
        } else {
            return imageMap[type];
        }
    };
    console.log("rerendering head (", x, ",", y, ")");

    return (
        <div class={`img-container ${isSelected ? 'selected' : ''}`}>
            <img 
                src={getImageSrc()} 
                alt={`Jewel type ${type}`} 
                className={`mfer-head mfer-head-${type} level-${levelID} ${isSelected ? 'selected' : ''} ${shouldBeCleared ? 'to-clear' : ''}`}
                onClick={onClick}
                style={{ left: `${x * 50}px`, top: `${y * 50}px` }}
            />
        </div>
    );
}, areEqual);

export default MferHead;
